"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[434],{

/***/ 3767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n            html,\n            body,\n            #__next {\n                height: 100%;\n            }\n\n            body {\n                margin: 0;\n            }\n\n            .MuiCardHeader-action .MuiIconButton-root {\n                padding: 4px;\n                width: 28px;\n                height: 28px;\n            }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var GlobalStyle = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .Global */ .xB, _objectSpread({}, props, {
        styles: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject())
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalStyle);


/***/ }),

/***/ 7434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Summary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(1599);
// EXTERNAL MODULE: ./node_modules/react-router/index.js
var react_router = __webpack_require__(6974);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(5113);
// EXTERNAL MODULE: ./node_modules/@mui/material/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(6720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(9226);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(8396);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(8700);
// EXTERNAL MODULE: ./src/components/GlobalStyle.tsx
var GlobalStyle = __webpack_require__(3767);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(3946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(155);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Menu.js
var Menu = __webpack_require__(6236);
;// CONCATENATED MODULE: ./src/components/navbar/Navbar.tsx





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    svg {\n        width: 22px;\n        height: 22px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Navbar_IconButton = (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* default */.Z)(_templateObject());
function Navbar(param) {
    var onDrawerToggle = param.onDrawerToggle;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                alignItems: "center",
                sx: {
                    display: {
                        xs: 'block',
                        md: 'none'
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    sx: {
                        display: {
                            xs: 'block',
                            md: 'none'
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_IconButton, {
                        color: "inherit",
                        "aria-label": "Open drawer",
                        onClick: onDrawerToggle,
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                    })
                })
            })
        })
    }));
}
/* harmony default export */ var navbar_Navbar = (Navbar);

// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/layout.js
var layout = __webpack_require__(3065);
// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/bar-chart-2.js
var bar_chart_2 = __webpack_require__(7207);
// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/link.js
var icons_link = __webpack_require__(9130);
;// CONCATENATED MODULE: ./src/components/sidebar/summaryItems.tsx

var pagesSection = [
    {
        href: '/',
        icon: layout/* default */.Z,
        title: 'Summary'
    }, 
];
var elementsSection = [
    {
        href: '/details',
        icon: bar_chart_2/* default */.Z,
        title: 'Details / Export'
    }, 
];
var referencesSection = [
    {
        href: '/references',
        icon: icons_link/* default */.Z,
        title: '個別債券情報'
    }, 
];
var navItems = [
    {
        title: 'Summary',
        pages: pagesSection
    },
    {
        title: 'details',
        pages: elementsSection
    },
    {
        title: 'references',
        pages: referencesSection
    }, 
];
/* harmony default export */ var summaryItems = (navItems);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(7533);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js + 1 modules
var ListItemButton = __webpack_require__(6113);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(1964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(8462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(3852);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(9334);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(7918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(7922);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ExpandLess.js
var ExpandLess = __webpack_require__(1680);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ExpandMore.js
var ExpandMore = __webpack_require__(6571);
;// CONCATENATED MODULE: ./src/components/sidebar/SidebarNavListItem.tsx








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function SidebarNavListItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function SidebarNavListItem_templateObject() {
    var data = SidebarNavListItem_taggedTemplateLiteral([
        "\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    font-weight: ",
        ";\n    svg {\n        color: ",
        ";\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        opacity: 0.5;\n    }\n    &:hover {\n        background: rgba(0, 0, 0, 0.08);\n        color: ",
        ";\n    }\n    &.",
        " {\n        background-color: ",
        ";\n        span {\n            color: ",
        ";\n        }\n    }\n"
    ]);
    SidebarNavListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = SidebarNavListItem_taggedTemplateLiteral([
        "\n    margin: 0;\n    span {\n        color: ",
        ";\n        font-size: ",
        "px;\n        padding: 0 ",
        ";\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = SidebarNavListItem_taggedTemplateLiteral([
        "\n    font-weight: ",
        ";\n    height: 20px;\n    position: absolute;\n    right: 26px;\n    top: 12px;\n    background: ",
        ";\n    z-index: 1;\n    span.MuiChip-label,\n    span.MuiChip-label:hover {\n        font-size: 11px;\n        cursor: pointer;\n        color: ",
        ";\n        padding-left: ",
        ";\n        padding-right: ",
        ";\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = SidebarNavListItem_taggedTemplateLiteral([
        "\n    color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = SidebarNavListItem_taggedTemplateLiteral([
        "\n    color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var Item = (0,emotion_styled_browser_esm/* default */.Z)(ListItemButton/* default */.Z)(SidebarNavListItem_templateObject(), function(props) {
    return props.theme.spacing(props.depth && props.depth > 0 ? 2 : 3);
}, function(props) {
    return props.theme.spacing(props.depth && props.depth > 0 ? 2 : 3);
}, function(props) {
    return props.theme.spacing(props.depth && props.depth > 0 ? 14 : 8);
}, function(props) {
    return props.theme.spacing(props.depth && props.depth > 0 ? 4 : 7);
}, function(props) {
    return props.theme.typography.fontWeightRegular;
}, function(props) {
    return props.theme.sidebar.color;
}, function(props) {
    return props.theme.sidebar.color;
}, function(props) {
    return props.activeclassname;
}, function(props) {
    return (0,polished_esm/* darken */._j)(0.03, props.theme.sidebar.background);
}, function(props) {
    return props.theme.sidebar.color;
});
var Title = (0,emotion_styled_browser_esm/* default */.Z)(ListItemText/* default */.Z)(_templateObject1(), function(props) {
    return (0,polished_esm/* rgba */.m4)(props.theme.sidebar.color, props.depth && props.depth > 0 ? 0.7 : 1);
}, function(props) {
    return props.theme.typography.body1.fontSize;
}, function(props) {
    return props.theme.spacing(4);
});
var Badge = (0,emotion_styled_browser_esm/* default */.Z)(Chip/* default */.Z)(_templateObject2(), function(props) {
    return props.theme.typography.fontWeightBold;
}, function(props) {
    return props.theme.sidebar.badge.background;
}, function(props) {
    return props.theme.sidebar.badge.color;
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
});
var ExpandLessIcon = (0,emotion_styled_browser_esm/* default */.Z)(ExpandLess/* default */.Z)(_templateObject3(), function(props) {
    return (0,polished_esm/* rgba */.m4)(props.theme.sidebar.color, 0.5);
});
var ExpandMoreIcon = (0,emotion_styled_browser_esm/* default */.Z)(ExpandMore/* default */.Z)(_templateObject4(), function(props) {
    return (0,polished_esm/* rgba */.m4)(props.theme.sidebar.color, 0.5);
});
var SidebarNavListItem = function(props) {
    var title = props.title, href = props.href, _depth = props.depth, depth = _depth === void 0 ? 0 : _depth, children = props.children, Icon = props.icon, badge = props.badge, tmp = props.open, openProp = tmp === void 0 ? false : tmp;
    var pathname = (0,router.useRouter)().pathname;
    var ref = _slicedToArray(react.useState(openProp), 2), open = ref[0], setOpen = ref[1];
    var handleToggle = function() {
        setOpen(function(state) {
            return !state;
        });
    };
    if (children) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    depth: depth,
                    onClick: handleToggle,
                    children: [
                        Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                            depth: depth,
                            children: [
                                title,
                                badge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                    label: badge
                                })
                            ]
                        }),
                        open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLessIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMoreIcon, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: open,
                    children: children
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
            depth: depth,
            className: pathname == href ? 'active' : '',
            activeclassname: "active",
            children: [
                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                    depth: depth,
                    children: [
                        title,
                        badge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                            label: badge
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var sidebar_SidebarNavListItem = (SidebarNavListItem);

;// CONCATENATED MODULE: ./src/components/sidebar/reduceChildRoutes.tsx




var reduceChildRoutes = function(props) {
    var items = props.items, page = props.page, depth = props.depth, currentRoute = props.currentRoute;
    if (page.children) {
        var open = currentRoute.includes(page.href);
        items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_SidebarNavListItem, {
            depth: depth,
            icon: page.icon,
            badge: page.badge,
            open: !!open,
            title: page.title,
            href: page.href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_SidebarNavList, {
                depth: depth + 1,
                pages: page.children
            })
        }, page.title));
    } else {
        items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_SidebarNavListItem, {
            depth: depth,
            href: page.href,
            icon: page.icon,
            badge: page.badge,
            title: page.title
        }, page.title));
    }
    return items;
};
/* harmony default export */ var sidebar_reduceChildRoutes = (reduceChildRoutes);

;// CONCATENATED MODULE: ./src/components/sidebar/SidebarNavList.tsx




var SidebarNavList = function(props) {
    var pages = props.pages, depth = props.depth;
    var pathname = (0,router.useRouter)().pathname;
    var childRoutes = pages.reduce(function(items, page) {
        return sidebar_reduceChildRoutes({
            items: items,
            page: page,
            currentRoute: pathname,
            depth: depth
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: childRoutes
    }));
};
/* harmony default export */ var sidebar_SidebarNavList = (SidebarNavList);

;// CONCATENATED MODULE: ./src/components/sidebar/SidebarNavSection.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SidebarNavSection_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SidebarNavSection_templateObject() {
    var data = SidebarNavSection_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    padding: ",
        " ",
        "\n        ",
        ";\n    opacity: 0.4;\n    text-transform: uppercase;\n    display: block;\n"
    ]);
    SidebarNavSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var SidebarNavSection_Title = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(SidebarNavSection_templateObject(), function(props) {
    return props.theme.sidebar.color;
}, function(props) {
    return props.theme.typography.caption.fontSize;
}, function(props) {
    return props.theme.spacing(4);
}, function(props) {
    return props.theme.spacing(7);
}, function(props) {
    return props.theme.spacing(1);
});
var SidebarNavSection = function(props) {
    var title = props.title, pages = props.pages, tmp = props.component, Component = tmp === void 0 ? 'nav' : tmp, rest = _objectWithoutProperties(props, [
        "title",
        "pages",
        "component"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, _objectSpread({}, rest, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarNavSection_Title, {
                variant: "subtitle2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_SidebarNavList, {
                pages: pages,
                depth: 0
            })
        ]
    })));
};
/* harmony default export */ var sidebar_SidebarNavSection = (SidebarNavSection);

;// CONCATENATED MODULE: ./src/components/sidebar/SidebarNav.tsx









function SidebarNav_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SidebarNav_templateObject() {
    var data = SidebarNav_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-right: 1px solid rgba(0, 0, 0, 0.12);\n    flex-grow: 1;\n"
    ]);
    SidebarNav_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SidebarNav_templateObject1() {
    var data = SidebarNav_taggedTemplateLiteral([
        "\n    ",
        "\n"
    ]);
    SidebarNav_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SidebarNav_templateObject2() {
    var data = SidebarNav_taggedTemplateLiteral([
        "\n    ",
        "\n"
    ]);
    SidebarNav_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SidebarNav_templateObject3() {
    var data = SidebarNav_taggedTemplateLiteral([
        "\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n"
    ]);
    SidebarNav_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var baseScrollbar = function(props) {
    return (0,emotion_react_browser_esm/* css */.iv)(SidebarNav_templateObject(), props.theme.sidebar.background);
};
var Scrollbar = emotion_styled_browser_esm/* default.div */.Z.div(SidebarNav_templateObject1(), baseScrollbar);
var PerfectScrollbar = (0,emotion_styled_browser_esm/* default */.Z)((lib_default()))(SidebarNav_templateObject2(), baseScrollbar);
var Items = emotion_styled_browser_esm/* default.div */.Z.div(SidebarNav_templateObject3(), function(props) {
    return props.theme.spacing(2.5);
}, function(props) {
    return props.theme.spacing(2.5);
});
var SidebarNav = function(param) {
    var items = param.items;
    var theme = (0,useTheme/* default */.Z)();
    var matches = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('md'));
    var ScrollbarComponent = matches ? PerfectScrollbar : Scrollbar;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollbarComponent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
            disablePadding: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Items, {
                children: items && items.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(sidebar_SidebarNavSection, {
                        component: "div",
                        pages: item.pages,
                        title: item.title
                    }, item.title);
                })
            })
        })
    }));
};
/* harmony default export */ var sidebar_SidebarNav = (SidebarNav);

;// CONCATENATED MODULE: ./src/components/sidebar/Sidebar.tsx







function Sidebar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Sidebar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Sidebar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Sidebar_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Sidebar_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Sidebar_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Sidebar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Sidebar_templateObject() {
    var data = Sidebar_taggedTemplateLiteral([
        "\n    border-right: 0;\n\n    > div {\n        border-right: 0;\n    }\n"
    ]);
    Sidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Sidebar_templateObject1() {
    var data = Sidebar_taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    background-color: ",
        ";\n    font-family: ",
        ";\n    justify-content: center;\n    cursor: pointer;\n    flex-grow: 0;\n    min-height: 56px;\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    &:hover {\n        background-color: ",
        ";\n    }\n"
    ]);
    Sidebar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Sidebar_Drawer = (0,emotion_styled_browser_esm/* default */.Z)(Drawer/* default */.ZP)(Sidebar_templateObject());
var Brand = (0,emotion_styled_browser_esm/* default */.Z)(ListItemButton/* default */.Z)(Sidebar_templateObject1(), function(props) {
    return props.theme.typography.h5.fontSize;
}, function(props) {
    return props.theme.typography.fontWeightMedium;
}, function(props) {
    return props.theme.sidebar.header.color;
}, function(props) {
    return props.theme.sidebar.header.background;
}, function(props) {
    return props.theme.typography.fontFamily;
}, function(props) {
    return props.theme.spacing(6);
}, function(props) {
    return props.theme.spacing(6);
}, function(props) {
    return props.theme.sidebar.header.background;
});
var Sidebar = function(_param) {
    var items = _param.items, rest = Sidebar_objectWithoutProperties(_param, [
        "items"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Sidebar_Drawer, Sidebar_objectSpread({
        variant: "permanent"
    }, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: "/gdtb-logo.png",
                        width: 200,
                        height: 70,
                        objectFit: 'contain'
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_SidebarNav, {
                items: items
            })
        ]
    })));
};
/* harmony default export */ var sidebar_Sidebar = (Sidebar);

;// CONCATENATED MODULE: ./src/components/Footer.tsx



function Footer() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        item: true,
        xs: 12,
        justifyContent: "center",
        my: 4,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "caption",
            children: "\xa9 ".concat(new Date().getFullYear(), " - JPX Market Innovation & Research, Inc.")
        })
    }));
}
/* harmony default export */ var components_Footer = (Footer);

;// CONCATENATED MODULE: ./src/layouts/Summary.tsx













function Summary_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Summary_templateObject() {
    var data = Summary_taggedTemplateLiteral([
        "\n    display: flex;\n    min-height: 100vh;\n"
    ]);
    Summary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Summary_templateObject1() {
    var data = Summary_taggedTemplateLiteral([
        "\n    ",
        " {\n        width: ",
        "px;\n        flex-shrink: 0;\n    }\n"
    ]);
    Summary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Summary_templateObject2() {
    var data = Summary_taggedTemplateLiteral([
        "\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n"
    ]);
    Summary_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Summary_templateObject3() {
    var data = Summary_taggedTemplateLiteral([
        "\n    flex: 1;\n    background: ",
        ";\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        flex: none;\n    }\n\n    .MuiPaper-root .MuiPaper-root {\n        box-shadow: none;\n    }\n"
    ]);
    Summary_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var drawerWidth = 258;
var Root = emotion_styled_browser_esm/* default.div */.Z.div(Summary_templateObject());
var Summary_Drawer = emotion_styled_browser_esm/* default.div */.Z.div(Summary_templateObject1(), function(props) {
    return props.theme.breakpoints.up('md');
}, drawerWidth);
var AppContent = emotion_styled_browser_esm/* default.div */.Z.div(Summary_templateObject2());
var Summary_Paper = (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z)(spacing/* default */.ZP);
var MainContent = (0,emotion_styled_browser_esm/* default */.Z)(Summary_Paper)(Summary_templateObject3(), function(props) {
    return props.theme.palette.background.default;
});
var Summary = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), mobileOpen = ref[0], setMobileOpen = ref[1];
    var handleDrawerToggle = function() {
        setMobileOpen(!mobileOpen);
    };
    var theme = (0,useTheme/* default */.Z)();
    var isLgUp = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('lg'));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary_Drawer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: 'block',
                                lg: 'none'
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_Sidebar, {
                            PaperProps: {
                                style: {
                                    width: drawerWidth
                                }
                            },
                            variant: "temporary",
                            open: mobileOpen,
                            onClose: handleDrawerToggle,
                            items: summaryItems
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar_Sidebar, {
                            PaperProps: {
                                style: {
                                    width: drawerWidth
                                }
                            },
                            items: summaryItems
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_Navbar, {
                        onDrawerToggle: handleDrawerToggle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContent, {
                        p: isLgUp ? 12 : 5,
                        children: [
                            children,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Outlet */.j3, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
                ]
            })
        ]
    }));
};
/* harmony default export */ var layouts_Summary = (Summary);


/***/ })

}]);